var exports = {
  "G": "buttonGroup__v1-yct",
};

module.exports = exports;
